import { Platform } from 'react-native';


const TextInput = Platform.select({
  ios: () => require('./Component/TextInput.native').default,
  android: () => require('./Component/TextInput.native').default,
  web: () => require('./Component/TextInput.web').default,
  default: () => require('./Component/TextInput.web').default,
})();

export default TextInput; 